<zag-form-field [label]="label()" [hint]="hint()" [error]="error()" [required]="required()" [forId]="controlId()">
  <div
    class="zag-translatable-text-field"
    [class.zag-translatable-text-field--readonly]="readonly()"
    [class.zag-translatable-text-field--disabled]="isDisabled()"
  >
    <div class="zag-translatable-text-field__tabs" role="tablist" [attr.aria-label]="'translatableInput.tabsLabel' | translate">
      @for (language of languages(); track language; let index = $index) {
      <button
        zagButton
        [zagButton]="activeLanguage() === language ? 'tonal' : 'outlined'"
        [zagType]="activeLanguage() === language ? 'primary' : 'secondary'"
        zagSize="sm"
        type="button"
        class="zag-translatable-text-field__tab"
        role="tab"
        [id]="tabId(language)"
        [attr.aria-label]="('translatableInput.languageTab.' + language) | translate"
        [attr.aria-selected]="activeLanguage() === language"
        [attr.aria-controls]="panelId()"
        [attr.tabindex]="activeLanguage() === language ? 0 : -1"
        [disabled]="isDisabled()"
        (click)="selectLanguage(language)"
        (keydown)="onTabKeydown($event, index)"
      >
        <span class="zag-translatable-text-field__tab-label">{{ language | uppercase }}</span>
        <span
          class="zag-translatable-text-field__tab-indicator"
          [class.zag-translatable-text-field__tab-indicator--filled]="filledLanguages().has(language)"
          [attr.aria-label]="
            (filledLanguages().has(language)
              ? 'translatableInput.translationStatus.filled'
              : 'translatableInput.translationStatus.empty'
            ) | translate
          "
        ></span>
      </button>
      }
    </div>

    @if (!hasActiveText()) { @if ((value() | zagTranslated: field() : null : activeLanguage()); as fallbackPreview) {
    <span class="zag-translatable-text-field__fallback">{{ fallbackPreview }}</span>
    } }

    <div class="zag-translatable-text-field__panel" role="tabpanel" [id]="panelId()" [attr.aria-labelledby]="tabId(activeLanguage())">
      <zag-input
        [id]="controlId()"
        [name]="name()"
        [inputClass]="inputClass()"
        [placeholder]="placeholder()"
        [disabled]="isDisabled()"
        [readonly]="readonly()"
        [required]="inputRequired()"
        [multiline]="multiline()"
        [rows]="rows()"
        [value]="activeText()"
        [ariaDescribedby]="describedBy()"
        (valueChange)="onTextChange($event)"
        (focusout)="onBlur()"
      />
    </div>
  </div>
</zag-form-field>
